// extracted by mini-css-extract-plugin
module.exports = {"colorPrimary":"#00A4EF","colorSecondary":"#fff","linkPanelAnimationDurationMilliseconds":"500"};